import type { RequestStatus } from '../lib/api.ts';

/**
 * Status has to be legible at a glance from a counter, so it reads as a
 * word rather than a colour alone -- colour is the secondary signal,
 * never the only one.
 */
const LABEL: Record<RequestStatus, string> = {
  open: 'Open',
  acknowledged: 'Seen by HQ',
  in_progress: 'Being worked on',
  resolved: 'Resolved',
  closed: 'Closed',
};

export const StatusPill = ({ status }: { readonly status: RequestStatus }) => (
  <span className={`pill pill-${status}`}>{LABEL[status]}</span>
);

export const statusLabel = (status: RequestStatus): string => LABEL[status];
